/**
 * Lotgenootje quiz — "Which Lotgenootje is right for you?"
 *
 * Copy comes from the JSON in sections/lg-quiz.liquid, lg-quiz-results.liquid and lg-quiz-reviews.liquid.
 * The branching logic below mirrors lotgenootje_quiz.json (4 paths, 7 results).
 *
 * Privacy: health answers (A3, B4) only pick reviews on the result page. They are kept in memory,
 * never stored, never added to cart attributes and never sent to Klaviyo.
 */
(function () {
  'use strict';

  var ANIMALS = ['sheep', 'panda', 'bear', 'rabbit', 'koala', 'dog', 'cat', 'elephant', 'sloth'];
  var FINISH = 'FINISH';
  var SAFETY = 'SAFETY';

  var AGE_OPTIONS = {
    u3: { goto: SAFETY, set: { ageBlocked: true } },
    '3_5': { set: { age: '3_5' } },
    '6_9': { set: { age: '6_9' } },
    '10_13': { set: { age: '10_13' } },
    '14p': { set: { age: '14_plus' } }
  };

  var LOGIC = {
    Q1: { options: {
      self: { goto: 'A2', set: { path: 'A' } },
      child: { goto: 'B2', set: { path: 'B' } },
      gift: { goto: 'C2', set: { path: 'C' } },
      work: { goto: 'D2', set: { path: 'D' } }
    } },

    A2: { next: 'A3', options: {
      sleep: { set: { result: 'deep_sleep' } },
      mind: { set: { result: 'calm_mind' } },
      stimuli: { set: { result: 'sensory_break' } },
      lonely: { set: { result: 'always_close' } }
    } },
    A3: { next: 'A4', multi: true, optional: true, health: true, options: {
      adhd: { tag: 'adhd' }, autism: { tag: 'autism' }, hsp: { tag: 'hsp' },
      trauma: { tag: 'trauma' }, grief: { tag: 'grief' }, none: { exclusive: true }
    } },
    A4: { next: 'A5', multi: true, options: {
      blanket: { show: ['weighted_blanket_comparison'] },
      tea_apps: { show: ['works_alongside'] },
      therapy: { show: ['works_alongside'] },
      nothing: { show: ['how_it_works'], exclusive: true }
    } },
    A5: { next: 'A6', options: { bed: {}, couch: {}, go: { addon: 'travel' }, always: { addon: 'mini' } } },
    A6: { options: {
      heavy: { goto: FINISH, set: { main: 'sloth', heavy: true } },
      classic: { goto: 'A7' },
      unsure: { goto: 'A7', set: { alt: 'sloth' } }
    } },
    A7: { next: FINISH, animals: true, surprise: '$result_default' },

    B2: { next: 'B3', set: { result: 'calm_nights_child' }, headlineVariant: true, options: {
      fall_asleep: { tag: 'child_fall_asleep' },
      wakes: { tag: 'child_wakes' },
      overstimulated: { tag: 'child_overstimulated' },
      anxious: { tag: 'child_anxious' },
      alone: { tag: 'child_alone' }
    } },
    B3: { next: 'B4', options: AGE_OPTIONS },
    B4: { next: 'B5', multi: true, optional: true, health: true, options: {
      adhd: { tag: 'adhd' }, autism: { tag: 'autism' }, hsp: { tag: 'hsp' }, none: { exclusive: true }
    } },
    B5: { next: 'B6', options: { bedtime: {}, after_school: {}, go: { addon: 'travel' } } },
    B6: { options: {
      heavy: { goto: FINISH, set: { main: 'sloth', heavy: true } },
      classic: { goto: 'B7' }
    } },
    B7: { next: FINISH, animals: true, surprise: 'sheep' },

    C2: { set: { result: 'gift_hugs_back' }, options: {
      partner: { goto: 'C3' },
      parent: { goto: 'C3' },
      friend: { goto: 'C3' },
      grandchild: { goto: 'C2_AGE', set: { recipientChild: true } }
    } },
    C2_AGE: { next: 'C3', options: AGE_OPTIONS },
    C3: { next: 'C4', options: {
      nights: { set: { giftDefault: 'sheep' } },
      mind: { set: { giftDefault: 'koala' } },
      comfort: { set: { giftDefault: 'sloth' } },
      special: { set: { giftDefault: 'panda' } }
    } },
    C4: { next: 'C5', options: {
      asap: { set: { urgency: 'asap' } },
      '1_2w': { show: ['next_day_delivery'] },
      season: { show: ['seasonal_banner', 'gift_card'] },
      norush: {}
    } },
    C5: { next: FINISH, animals: true, surprise: '$gift_default' },

    D2: { next: 'D3', set: { result: 'professionals' }, saveAs: 'work', options: {
      therapy: {}, education: {}, elderly: {}, youth: {}, other: {}
    } },
    D3: { next: FINISH, saveAs: 'quantity', options: {
      '1': {}, '2_5': { show: ['bundles'] }, '6p': { show: ['volume_form'] }
    } }
  };

  var PATHS = {
    A: ['Q1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7'],
    B: ['Q1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7'],
    C: ['Q1', 'C2', 'C3', 'C4', 'C5'],
    D: ['Q1', 'D2', 'D3']
  };

  // Extra blocks per result ("show on page")
  var RESULT_SHOW = {
    deep_sleep: [],
    calm_mind: ['care_line'],
    sensory_break: ['weighted_blanket_comparison'],
    always_close: ['care_line'],
    calm_nights_child: [],
    gift_hugs_back: ['next_day_delivery', 'gift_card'],
    professionals: ['volume_form']
  };

  // Review tags per result
  var RESULT_TAGS = {
    deep_sleep: ['sleep', 'skeptical'],
    calm_mind: ['stress', 'panic'],
    sensory_break: ['autism', 'adhd', 'hsp'],
    always_close: ['loneliness', 'grief'],
    calm_nights_child: ['parent'],
    gift_hugs_back: ['gift'],
    professionals: ['professional', 'therapist', 'teacher']
  };

  var OBJECTION_ORDER = [
    'weighted_blanket_comparison', 'works_alongside', 'how_it_works',
    'next_day_delivery', 'seasonal_banner', 'gift_card', 'bundles'
  ];

  /* ---------- helpers ---------- */

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function lines(value) {
    return String(value || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
  }

  function pipeParts(line) {
    return line.split('|').map(function (p) { return p.trim(); });
  }

  function csv(value) {
    return String(value || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function loadData() {
    var data = {
      texts: {}, assets: {}, questions: {}, education: [], animals: {}, results: {},
      content: {}, reviews: [], klaviyo: {}, travel: null, giftCard: null, allUrl: '/collections/all', loadingMs: 3000
    };
    document.querySelectorAll('script[data-lg-quiz-data]').forEach(function (el) {
      try {
        var json = JSON.parse(el.textContent);
        Object.keys(json).forEach(function (key) {
          if (key === 'part') return;
          if (key === 'texts') Object.assign(data.texts, json.texts);
          else if (key === 'reviews') data.reviews = data.reviews.concat(json.reviews || []);
          else data[key] = json[key];
        });
      } catch (error) {
        console.error('[lg-quiz] Could not read quiz data', error);
      }
    });

    Object.keys(data.questions).forEach(function (id) {
      var q = data.questions[id];
      q.answerList = lines(q.answers).map(function (line) {
        var p = pipeParts(line);
        return { id: p[0], label: p[1] || p[0], description: p[2] || '', why: p[3] || '' };
      });
    });
    return data;
  }

  /* ---------- quiz ---------- */

  function Quiz(app, data) {
    this.app = app;
    this.data = data;
    this.t = data.texts;
    this.screenEl = app.querySelector('[data-lgq-screen]');
    this.header = app.querySelector('[data-lgq-header]');
    this.progressEl = app.querySelector('[data-lgq-progress]');
    this.backBtn = app.querySelector('[data-lgq-back]');
    this.volumeForm = document.querySelector('[data-lgq-volume-form]');
    this.answers = {};
    this.history = [];
    this.timer = null;
    this.rendered = false;

    this.screenEl.addEventListener('click', this.onClick.bind(this));
    this.screenEl.addEventListener('submit', this.onSubmit.bind(this));
    this.backBtn.addEventListener('click', function () { window.history.back(); });
    window.addEventListener('popstate', this.onPopState.bind(this));

    var volumePosted = this.volumeForm &&
      (this.volumeForm.querySelector('[data-lgq-volume-success]') || this.volumeForm.querySelector('.lgq-volume-form__errors'));
    this.history = [{ type: volumePosted ? 'volume' : 'intro' }];
    window.history.replaceState({ lgq: 1 }, '');
    this.render();
  }

  Quiz.prototype = {
    current: function () {
      return this.history[this.history.length - 1];
    },

    push: function (screen) {
      this.history.push(screen);
      window.history.pushState({ lgq: this.history.length }, '');
      this.render();
    },

    replace: function (screen) {
      this.history[this.history.length - 1] = screen;
      this.render();
    },

    onPopState: function () {
      if (this.history.length > 1) {
        this.history.pop();
        this.render();
      }
    },

    restart: function () {
      this.answers = {};
      this.history = [{ type: 'question', id: 'Q1' }];
      window.history.pushState({ lgq: 1 }, '');
      this.render();
    },

    /* --- state derived from the answered questions in the current history --- */
    derive: function () {
      var self = this;
      var s = {
        path: null, result: null, main: null, alt: null, heavy: false, chosen: null,
        giftDefault: null, urgency: null, age: null, ageBlocked: false, recipientChild: false,
        addon: null, tags: [], show: [], variantAnswer: null, why: [], work: null, quantity: null
      };

      this.history.forEach(function (screen) {
        if (screen.type !== 'question') return;
        var id = screen.id;
        var logic = LOGIC[id] || {};
        var selected = self.answers[id] || [];
        if (!selected.length) return;

        if (logic.set) Object.assign(s, logic.set);

        if (logic.animals) {
          var pick = selected[0];
          if (ANIMALS.indexOf(pick) !== -1) {
            s.main = pick;
            s.chosen = pick;
          } else {
            s.main = logic.surprise;
          }
        } else {
          selected.forEach(function (answerId) {
            var option = (logic.options || {})[answerId] || {};
            if (option.set) Object.assign(s, option.set);
            if (option.tag) s.tags.push(option.tag);
            if (option.show) s.show = s.show.concat(option.show);
            if (option.addon) s.addon = option.addon;
          });
        }

        if (logic.headlineVariant) s.variantAnswer = selected[0];
        if (logic.saveAs) s[logic.saveAs] = selected[0];

        if (!logic.health) {
          var question = self.data.questions[id];
          selected.forEach(function (answerId) {
            var answer = question && question.answerList.find(function (a) { return a.id === answerId; });
            if (answer && answer.why) s.why.push(answer.why);
          });
        }
      });

      if (s.age) s.tags.push('age_' + s.age);
      return s;
    },

    educationIndexFor: function (questionId) {
      var key = questionId.toLowerCase();
      return this.data.education.findIndex(function (slide) {
        return csv(slide.after).indexOf(key) !== -1;
      });
    },

    progress: function () {
      var s = this.derive();
      var plan = (PATHS[s.path] || PATHS.A).slice();
      if (s.heavy) plan = plan.filter(function (id) { return id !== 'A7' && id !== 'B7'; });
      if (s.recipientChild && plan.indexOf('C2_AGE') === -1) plan.splice(plan.indexOf('C2') + 1, 0, 'C2_AGE');
      var self = this;
      var total = plan.length + 1 + plan.filter(function (id) { return self.educationIndexFor(id) !== -1; }).length;
      var position = this.history.filter(function (h) {
        return h.type === 'question' || h.type === 'education' || h.type === 'email';
      }).length;
      return Math.max(0, Math.min(100, Math.round((position / total) * 100)));
    },

    /* --- navigation --- */
    goToTarget: function (target) {
      if (target === FINISH) {
        this.push({ type: 'loading' });
      } else if (target === SAFETY) {
        this.push({ type: 'safety' });
      } else if (target) {
        this.push({ type: 'question', id: target });
      }
    },

    nextFromQuestion: function (questionId) {
      var logic = LOGIC[questionId] || {};
      var selected = this.answers[questionId] || [];
      var target = logic.next;
      if (!logic.multi && !logic.animals && selected[0]) {
        var option = (logic.options || {})[selected[0]];
        if (option && option.goto) target = option.goto;
      }

      var educationIndex = this.educationIndexFor(questionId);
      if (educationIndex !== -1 && target !== SAFETY) {
        this.push({ type: 'education', index: educationIndex, next: target });
      } else {
        this.goToTarget(target);
      }
    },

    toggleAnswer: function (questionId, answerId) {
      var logic = LOGIC[questionId] || {};
      var current = (this.answers[questionId] || []).slice();

      if (logic.multi) {
        var option = (logic.options || {})[answerId] || {};
        if (current.indexOf(answerId) !== -1) {
          current = current.filter(function (id) { return id !== answerId; });
        } else if (option.exclusive) {
          current = [answerId];
        } else {
          current = current.filter(function (id) {
            return !((logic.options || {})[id] || {}).exclusive;
          });
          current.push(answerId);
        }
      } else {
        current = [answerId];
      }

      this.answers[questionId] = current;
      this.updateSelection(questionId);
    },

    updateSelection: function (questionId) {
      var selected = this.answers[questionId] || [];
      this.screenEl.querySelectorAll('[data-answer]').forEach(function (card) {
        var isSelected = selected.indexOf(card.getAttribute('data-answer')) !== -1;
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      var next = this.screenEl.querySelector('[data-action="next"]');
      var hint = this.screenEl.querySelector('[data-lgq-hint]');
      if (next) next.disabled = !selected.length;
      if (hint) hint.hidden = !!selected.length;
    },

    /* --- events --- */
    onClick: function (event) {
      var target = event.target.closest('[data-action], [data-answer]');
      if (!target || !this.screenEl.contains(target)) return;
      var screen = this.current();

      if (target.hasAttribute('data-answer')) {
        this.toggleAnswer(screen.id, target.getAttribute('data-answer'));
        return;
      }

      switch (target.getAttribute('data-action')) {
        case 'start':
          this.push({ type: 'question', id: 'Q1' });
          break;
        case 'next':
          if ((this.answers[screen.id] || []).length) this.nextFromQuestion(screen.id);
          break;
        case 'skip':
          this.answers[screen.id] = [];
          this.nextFromQuestion(screen.id);
          break;
        case 'continue':
          this.goToTarget(screen.next);
          break;
        case 'email-skip':
          event.preventDefault();
          this.push({ type: 'result' });
          break;
        case 'retake':
          event.preventDefault();
          this.restart();
          break;
      }
    },

    onSubmit: function (event) {
      var form = event.target;
      if (!form.matches('[data-lgq-email-form]')) return;
      event.preventDefault();

      var input = form.querySelector('input[type="email"]');
      var error = form.querySelector('[data-lgq-email-error]');
      var email = input.value.trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      error.hidden = valid;
      input.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (!valid) {
        input.focus();
        return;
      }

      var consent = form.querySelector('input[type="checkbox"]').checked;
      var button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      var self = this;
      this.sendToKlaviyo(email, consent).then(function () {
        self.push({ type: 'result' });
      });
    },

    /* --- rendering --- */
    render: function () {
      clearTimeout(this.timer);
      var screen = this.current();
      var html = '';

      switch (screen.type) {
        case 'intro': html = this.renderIntro(); break;
        case 'question': html = this.renderQuestion(screen.id); break;
        case 'education': html = this.renderEducation(screen); break;
        case 'loading': html = this.renderLoading(); break;
        case 'email': html = this.renderEmail(); break;
        case 'result': html = this.renderResult(); break;
        case 'safety': html = this.renderSafety(); break;
        case 'volume': html = this.renderVolume(); break;
      }

      this.screenEl.innerHTML = html;
      this.screenEl.setAttribute('data-screen', screen.type);
      this.updateHeader(screen);
      this.afterRender(screen);

      if (this.rendered) {
        var top = this.app.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo(0, Math.max(0, top));
        var heading = this.screenEl.querySelector('[data-lgq-focus]');
        if (heading) heading.focus({ preventScroll: true });
      }
      this.rendered = true;
    },

    updateHeader: function (screen) {
      var withProgress = ['question', 'education', 'email'].indexOf(screen.type) !== -1;
      var withBack = withProgress;
      this.app.classList.toggle('lgq-is-bare', screen.type === 'loading');
      this.progressEl.hidden = !withProgress;
      this.backBtn.hidden = !withBack;

      if (withProgress) {
        var pct = screen.type === 'email' ? 100 : this.progress();
        this.progressEl.querySelector('[data-lgq-progress-fill]').style.width = pct + '%';
        this.progressEl.querySelector('[data-lgq-progress-value]').textContent = pct + '%';
        this.progressEl.querySelector('[data-lgq-progress-bar]').setAttribute('aria-valuenow', pct);
      }
    },

    afterRender: function (screen) {
      var self = this;
      if (screen.type === 'loading') {
        this.timer = setTimeout(function () {
          self.replace({ type: 'email' });
        }, this.data.loadingMs || 3000);
      }
      if (screen.type === 'question') this.updateSelection(screen.id);
      if (screen.type === 'result') {
        this.setCartAttributes();
        this.mountVolumeForm();
      }
      if (screen.type === 'volume') this.mountVolumeForm();
    },

    heading: function (text, className) {
      return '<h1 class="lgq-title ' + (className || '') + '" tabindex="-1" data-lgq-focus>' + esc(text) + '</h1>';
    },

    renderIntro: function () {
      var t = this.t;
      var check = this.data.assets.check;
      var usps = String(t.introTrust || '').split('|').map(function (item) { return item.trim(); }).filter(Boolean);
      var image = this.data.introImage || this.data.assets.education;
      return '' +
        '<div class="lgq-container lgq-intro">' +
          '<div class="lgq-intro__content">' +
            (t.introEyebrow ? '<p class="lgq-intro__eyebrow">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' +
              esc(t.introEyebrow) + '</p>' : '') +
            this.heading(t.introHeading, 'lgq-intro__title') +
            (t.introText ? '<p class="lgq-intro__lead">' + esc(t.introText) + '</p>' : '') +
            (usps.length ? '<ul class="lgq-intro__usps">' + usps.map(function (item) {
              return '<li><span class="lgq-intro__check" aria-hidden="true"><img src="' + esc(check) + '" alt="" width="14" height="14"></span><span>' + esc(item) + '</span></li>';
            }).join('') + '</ul>' : '') +
            '<div class="lgq-intro__cta">' +
              '<button type="button" class="lgq-btn" data-action="start">' +
                '<span>' + esc(t.introButton) + '</span>' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
          (image ? '<div class="lgq-intro__media">' +
            '<img src="' + esc(image) + '" alt="' + esc(this.data.introImageAlt || '') + '" width="1100" height="1200" fetchpriority="high">' +
          '</div>' : '') +
        '</div>';
    },

    stepNumber: function () {
      return this.history.filter(function (h) { return h.type === 'question'; }).length;
    },

    renderQuestion: function (id) {
      var t = this.t;
      var logic = LOGIC[id] || {};
      var q = this.data.questions[id] || { eyebrow: '', question: id, helper: '', answerList: [] };
      var eyebrow = (t.stepPrefix ? t.stepPrefix + ' ' + this.stepNumber() : '') + (q.eyebrow ? ': ' + q.eyebrow : '');
      var helper = q.helper || (logic.multi ? t.multiHint : '');
      var cards;

      if (logic.animals) {
        var self = this;
        var animals = ANIMALS.filter(function (a) { return self.hasProduct(a); });
        cards = '<div class="lgq-grid lgq-grid--animals">' +
          animals.map(function (a) { return self.animalCard(a); }).join('') +
          q.answerList.map(function (answer) { return self.answerCard(answer, 'lgq-card--wide'); }).join('') +
          '</div>';
      } else {
        cards = '<div class="lgq-grid">' + q.answerList.map(this.answerCard.bind(this)).join('') + '</div>';
      }

      return '' +
        '<div class="lgq-container">' +
          '<div class="lgq-head">' +
            '<p class="lgq-eyebrow">' + esc(eyebrow) + '</p>' +
            this.heading(q.question) +
            (helper ? '<p class="lgq-helper">' + esc(helper) + '</p>' : '') +
          '</div>' +
          cards +
          '<div class="lgq-actions">' +
            '<button type="button" class="lgq-btn" data-action="next" disabled>' + esc(t.next) + '</button>' +
            '<p class="lgq-hint" data-lgq-hint>' + esc(t.selectHint) + '</p>' +
            (logic.optional ? '<button type="button" class="lgq-link" data-action="skip">' + esc(t.skip) + '</button>' : '') +
          '</div>' +
        '</div>';
    },

    answerCard: function (answer, extraClass) {
      return '' +
        '<button type="button" class="lgq-card ' + (typeof extraClass === 'string' ? extraClass : '') + '" data-answer="' + esc(answer.id) + '" aria-pressed="false">' +
          '<span class="lgq-card__title">' + esc(answer.label) + '</span>' +
          (answer.description ? '<span class="lgq-card__text">' + esc(answer.description) + '</span>' : '') +
        '</button>';
    },

    animalCard: function (animalId) {
      var animal = this.data.animals[animalId];
      var image = animal.image || (animal.product && animal.product.image);
      var label = animal.label || (animal.product && animal.product.title) || animalId;
      return '' +
        '<button type="button" class="lgq-card lgq-card--animal" data-answer="' + animalId + '" aria-pressed="false">' +
          '<span class="lgq-card__media">' +
            (image ? '<img src="' + esc(image) + '" alt="" loading="lazy" width="300" height="300">' : '') +
          '</span>' +
          '<span class="lgq-card__title">' + esc(label) + '</span>' +
          (animal.weight ? '<span class="lgq-card__text">' + esc(animal.weight) + '</span>' : '') +
        '</button>';
    },

    renderEducation: function (screen) {
      var slide = this.data.education[screen.index] || {};
      var check = this.data.assets.check;
      var image = slide.image || this.data.assets.education;
      var benefits = (slide.benefits || []).filter(function (b) { return b.title || b.text; });
      return '' +
        '<div class="lgq-container lgq-education">' +
          '<div class="lgq-education__media">' +
            '<img src="' + esc(image) + '" alt="' + esc(slide.imageAlt || '') + '" width="521" height="400">' +
          '</div>' +
          '<div class="lgq-education__body">' +
            '<div class="lgq-education__copy">' +
              (slide.eyebrow ? '<p class="lgq-eyebrow">' + esc(slide.eyebrow) + '</p>' : '') +
              this.heading(slide.heading, 'lgq-title--education') +
              (slide.text ? '<p class="lgq-education__text">' + esc(slide.text) + '</p>' : '') +
            '</div>' +
            (benefits.length ? '<ul class="lgq-benefits">' + benefits.map(function (b) {
              return '<li class="lgq-benefit">' +
                '<span class="lgq-benefit__icon"><img src="' + esc(check) + '" alt="" width="14" height="14"></span>' +
                '<span class="lgq-benefit__copy"><span class="lgq-benefit__title">' + esc(b.title) + '</span>' +
                (b.text ? '<span class="lgq-benefit__text">' + esc(b.text) + '</span>' : '') + '</span>' +
              '</li>';
            }).join('') + '</ul>' : '') +
            '<div class="lgq-education__cta">' +
              '<button type="button" class="lgq-btn" data-action="continue">' + esc(slide.button) + '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    },

    renderLoading: function () {
      var t = this.t;
      return '' +
        '<div class="lgq-loading">' +
          '<div class="lgq-loading__card">' +
            '<img class="lgq-loading__spinner" src="' + esc(this.data.assets.loader) + '" alt="" width="100" height="100">' +
            '<div class="lgq-loading__copy">' +
              this.heading(t.loadingHeading, 'lgq-title--loading') +
              (t.loadingText ? '<p class="lgq-loading__text">' + esc(t.loadingText) + '</p>' : '') +
            '</div>' +
            (t.loadingTrust ? '<p class="lgq-loading__trust"><img src="' + esc(this.data.assets.shield) + '" alt="" width="16" height="16">' + esc(t.loadingTrust) + '</p>' : '') +
          '</div>' +
        '</div>';
    },

    renderEmail: function () {
      var t = this.t;
      var required = this.derive().path === 'D';
      return '' +
        '<div class="lgq-container lgq-email">' +
          '<div class="lgq-head">' +
            this.heading(t.emailHeading) +
            (t.emailText ? '<p class="lgq-lead">' + esc(t.emailText) + '</p>' : '') +
          '</div>' +
          '<form class="lgq-email__form" data-lgq-email-form novalidate>' +
            '<label class="lgq-field lgq-field--full">' +
              '<span class="visually-hidden">' + esc(t.emailPlaceholder) + '</span>' +
              '<input type="email" name="email" autocomplete="email" placeholder="' + esc(t.emailPlaceholder) + '" required>' +
            '</label>' +
            '<p class="lgq-error" data-lgq-email-error hidden>' + esc(t.emailError) + '</p>' +
            '<label class="lgq-consent">' +
              '<input type="checkbox" name="consent">' +
              '<span>' + esc(t.emailConsent) + '</span>' +
            '</label>' +
            '<div class="lgq-actions">' +
              '<button type="submit" class="lgq-btn">' + esc(t.emailButton) + '</button>' +
              (required ? '' : '<a href="#" class="lgq-link" data-action="email-skip">' + esc(t.emailSkip) + '</a>') +
            '</div>' +
          '</form>' +
        '</div>';
    },

    renderSafety: function () {
      var t = this.t;
      var gift = this.data.giftCard;
      return '' +
        '<div class="lgq-container lgq-safety">' +
          '<div class="lgq-head">' +
            this.heading(t.safetyHeading) +
            (t.safetyText ? '<p class="lgq-lead">' + esc(t.safetyText) + '</p>' : '') +
          '</div>' +
          '<div class="lgq-actions">' +
            (gift ? '<a class="lgq-btn" href="' + esc(gift.url) + '">' + esc(t.safetyButton) + '</a>' : '') +
            '<a href="#" class="lgq-link" data-action="retake">' + esc(t.safetyRetake) + '</a>' +
          '</div>' +
        '</div>';
    },

    renderVolume: function () {
      return '' +
        '<div class="lgq-container lgq-result">' +
          '<div class="lgq-panel" data-lgq-volume-slot></div>' +
          '<div class="lgq-result__footer">' +
            '<a href="#" class="lgq-link" data-action="retake">' + esc(this.t.retake) + '</a>' +
          '</div>' +
        '</div>';
    },

    /* --- result --- */
    resultDefault: function (resultId, s) {
      switch (resultId) {
        case 'deep_sleep': return s.heavy ? 'sloth' : 'sheep';
        case 'calm_mind': return 'koala';
        case 'sensory_break': return 'dog';
        case 'always_close': return 'sloth';
        case 'calm_nights_child': return 'sheep';
        case 'gift_hugs_back': return s.giftDefault || 'sheep';
        default: return 'bear';
      }
    },

    hasProduct: function (animalId) {
      var animal = this.data.animals[animalId];
      return !!(animal && animal.product);
    },

    isPreorder: function (animalId) {
      var animal = this.data.animals[animalId];
      return !!(animal && animal.preorder);
    },

    /**
     * Returns the recommended animals, best match first: the main pick, the second option
     * (heavy hug / "not sure yet"), then the other animals in the order of the Animal blocks,
     * until there are at least `recommendCount` products.
     */
    resolvePicks: function (resultId, s) {
      var self = this;
      // Pre-order rule: a gift that must arrive ASAP never gets a pre-order animal
      var asap = s.urgency === 'asap';
      var usable = function (a) {
        return !!a && self.hasProduct(a) && !(asap && self.isPreorder(a));
      };

      var first = [];
      var bundle = null;

      if (resultId === 'professionals') {
        first = (s.quantity === '1' ? ['bear'] : ['bear', 'dog']).filter(usable);
        if (first.length > 1) bundle = first.slice();
      } else {
        var fallback = this.resultDefault(resultId, s);
        var main = s.main || fallback;
        if (main === '$result_default') main = fallback;
        if (main === '$gift_default') main = s.giftDefault || 'sheep';
        if (!usable(main)) main = [fallback, s.giftDefault, 'sheep'].find(usable) || null;

        var alt = null;
        if (s.heavy && s.chosen) alt = s.chosen;
        if (s.alt) alt = s.alt;
        first = [main, alt];
      }

      var count = Math.max(1, parseInt(this.data.recommendCount, 10) || 3);
      var list = [];
      first.concat(Object.keys(this.data.animals), ANIMALS).forEach(function (a) {
        if (usable(a) && list.indexOf(a) === -1) list.push(a);
      });

      return { list: list.slice(0, Math.max(count, first.filter(usable).length)), bundle: bundle };
    },

    resultData: function () {
      var s = this.derive();
      var resultId = s.result || 'deep_sleep';
      var result = this.data.results[resultId] || { name: '', headline: '', recognition: '', bullets: '', variants: '' };
      var picks = this.resolvePicks(resultId, s);
      return { s: s, id: resultId, result: result, picks: picks };
    },

    renderResult: function () {
      var t = this.t;
      var r = this.resultData();
      var s = r.s;
      var result = r.result;
      var self = this;

      var headline = result.headline;
      if (s.variantAnswer) {
        lines(result.variants).forEach(function (line) {
          var p = pipeParts(line);
          if (p[0] === s.variantAnswer && p[1]) headline = p[1];
        });
      }

      var why = [];
      s.why.concat(lines(result.bullets)).forEach(function (line) {
        if (why.length < 3 && why.indexOf(line) === -1) why.push(line);
      });

      var show = s.show.concat(RESULT_SHOW[r.id] || []);
      var objections = OBJECTION_ORDER.filter(function (key, i) {
        return show.indexOf(key) !== -1;
      });

      var html = '<div class="lgq-container lgq-result">';

      html += '<div class="lgq-head">' +
        (result.name ? '<p class="lgq-eyebrow">' + esc((t.resultEyebrow ? t.resultEyebrow + ': ' : '') + result.name) + '</p>' : '') +
        this.heading(headline) +
        (result.recognition ? '<p class="lgq-lead">' + esc(result.recognition) + '</p>' : '') +
      '</div>';

      html += this.renderProducts(r.picks);

      if (why.length) {
        html += '<section class="lgq-panel">' +
          '<h2 class="lgq-h2">' + esc(t.whyHeading) + '</h2>' +
          '<ul class="lgq-benefits">' + why.map(function (line) {
            return '<li class="lgq-benefit"><span class="lgq-benefit__icon"><img src="' + esc(self.data.assets.check) + '" alt="" width="14" height="14"></span>' +
              '<span class="lgq-benefit__copy"><span class="lgq-benefit__title">' + esc(line) + '</span></span></li>';
          }).join('') + '</ul>' +
        '</section>';
      }

      html += this.renderReviews(r.id, s);

      objections.forEach(function (key) { html += self.renderContent(key); });

      if (show.indexOf('volume_form') !== -1 && this.volumeForm) {
        html += '<section class="lgq-panel" data-lgq-volume-slot>' +
          this.contentHeading('volume_form') +
        '</section>';
      }

      html += this.renderAddon(s, r.picks);

      var trust = lines(t.trustItems);
      if (trust.length) {
        html += '<ul class="lgq-trust-strip">' + trust.map(function (item) {
          return '<li><img src="' + esc(self.data.assets.check) + '" alt="" width="14" height="14">' + esc(item) + '</li>';
        }).join('') + '</ul>';
      }

      if (show.indexOf('care_line') !== -1 && t.careLine) {
        html += '<p class="lgq-care">' + esc(t.careLine) + '</p>';
      }

      html += '<div class="lgq-result__footer">' +
        '<a href="#" class="lgq-link" data-action="retake">' + esc(t.retake) + '</a>' +
        '<span aria-hidden="true">|</span>' +
        '<a href="' + esc(this.data.allUrl) + '" class="lgq-link">' + esc(t.allLabel) + '</a>' +
      '</div>';

      html += '</div>';
      return html;
    },

    productCard: function (animalId, isBest) {
      var animal = this.data.animals[animalId];
      var product = animal.product;
      var image = animal.image || product.image;
      var t = this.t;
      return '' +
        '<article class="lgq-product' + (isBest ? ' is-best' : '') + '">' +
          '<a class="lgq-product__media" href="' + esc(product.url) + '">' +
            (image ? '<img src="' + esc(image) + '" alt="' + esc(product.title) + '" loading="lazy" width="360" height="360">' : '') +
          '</a>' +
          '<div class="lgq-product__body">' +
            '<a class="lgq-product__name" href="' + esc(product.url) + '">' + esc(product.title) + '</a>' +
            (animal.weight ? '<p class="lgq-product__meta">' + esc(animal.weight) + '</p>' : '') +
            '<p class="lgq-product__price">' +
              (product.compareAt ? '<s>' + esc(product.compareAt) + '</s>' : '') +
              '<span>' + esc(product.price) + '</span>' +
            '</p>' +
            '<a class="lgq-btn" href="' + esc(product.url) + '">' + esc(t.view) + '</a>' +
          '</div>' +
        '</article>';
    },

    renderProducts: function (picks) {
      var self = this;
      if (!picks.list.length) return '';

      return '<div class="lgq-products">' +
        '<div class="lgq-products__row" style="--lgq-cols: ' + Math.min(picks.list.length, 4) + '">' +
          picks.list.map(function (a, index) {
            // Professionals get the bear + dog bundle as their joint best match
            var isBest = picks.bundle ? picks.bundle.indexOf(a) !== -1 : index === 0;
            return self.productCard(a, isBest);
          }).join('') +
        '</div>' +
      '</div>';
    },

    renderReviews: function (resultId, s) {
      var wanted = (RESULT_TAGS[resultId] || []).concat(s.tags);
      var personal = s.tags;
      var picked = this.data.reviews.map(function (review, index) {
        var tags = csv(review.tags);
        var score = tags.filter(function (tag) { return wanted.indexOf(tag) !== -1; }).length +
          tags.filter(function (tag) { return personal.indexOf(tag) !== -1; }).length;
        return { review: review, index: index, score: score };
      }).filter(function (item) {
        return item.score > 0 && item.review.text;
      }).sort(function (a, b) {
        return b.score - a.score || a.index - b.index;
      }).slice(0, 3);

      if (!picked.length) return '';

      return '<section class="lgq-section">' +
        '<h2 class="lgq-h2">' + esc(this.t.reviewsHeading) + '</h2>' +
        '<div class="lgq-reviews">' + picked.map(function (item) {
          var review = item.review;
          var rating = Math.max(1, Math.min(5, parseInt(review.rating, 10) || 5));
          return '<figure class="lgq-review">' +
            '<p class="lgq-review__stars" aria-label="' + rating + '/5">' + '★★★★★'.slice(0, rating) + '<span>' + '★★★★★'.slice(rating) + '</span></p>' +
            (review.title ? '<p class="lgq-review__title">' + esc(review.title) + '</p>' : '') +
            '<blockquote class="lgq-review__text">' + esc(review.text) + '</blockquote>' +
            '<figcaption class="lgq-review__author">' + esc(review.name) +
              (review.meta ? '<span>' + esc(review.meta) + '</span>' : '') +
            '</figcaption>' +
          '</figure>';
        }).join('') + '</div>' +
      '</section>';
    },

    contentHeading: function (key) {
      var content = this.data.content[key];
      if (!content) return '';
      return (content.heading ? '<h2 class="lgq-h2">' + esc(content.heading) + '</h2>' : '') +
        (content.text ? '<div class="lgq-rte">' + content.text + '</div>' : '');
    },

    renderContent: function (key, extraClass) {
      var content = this.data.content[key];
      if (!content || (!content.heading && !content.text)) return '';
      var link = content.link || (key === 'gift_card' && this.data.giftCard ? this.data.giftCard.url : '');
      return '<section class="lgq-panel ' + (extraClass || '') + '">' +
        this.contentHeading(key) +
        (content.button && link ? '<a class="lgq-btn lgq-btn--outline" href="' + esc(link) + '">' + esc(content.button) + '</a>' : '') +
      '</section>';
    },

    renderAddon: function (s, picks) {
      var t = this.t;
      var addon = null;
      var text = '';
      if (s.addon === 'travel' && this.data.travel) {
        addon = this.data.travel;
        text = t.addonTravel;
      } else if (s.addon === 'mini' && picks.list[0]) {
        var mainAnimal = this.data.animals[picks.list[0]];
        if (mainAnimal && mainAnimal.mini) {
          addon = mainAnimal.mini;
          text = t.addonMini;
        }
      }

      var offer = this.renderContent('sibling_offer', 'lgq-panel--offer');
      if (!addon && !offer) return '';

      var html = '';
      if (addon) {
        html += '<section class="lgq-panel lgq-addon">' +
          (t.addonHeading ? '<h2 class="lgq-h2">' + esc(t.addonHeading) + '</h2>' : '') +
          '<div class="lgq-addon__row">' +
            (addon.image ? '<img class="lgq-addon__image" src="' + esc(addon.image) + '" alt="" loading="lazy" width="96" height="96">' : '') +
            '<div class="lgq-addon__body">' +
              '<a class="lgq-addon__name" href="' + esc(addon.url) + '">' + esc(addon.title) + '</a>' +
              (text ? '<p class="lgq-addon__text">' + esc(text) + '</p>' : '') +
              '<p class="lgq-product__price">' + (addon.compareAt ? '<s>' + esc(addon.compareAt) + '</s>' : '') + '<span>' + esc(addon.price) + '</span></p>' +
            '</div>' +
            '<a class="lgq-btn lgq-btn--small" href="' + esc(addon.url) + '">' + esc(t.view) + '</a>' +
          '</div>' +
        '</section>';
      }
      return html + offer;
    },

    mountVolumeForm: function () {
      var slot = this.screenEl.querySelector('[data-lgq-volume-slot]');
      if (!slot || !this.volumeForm) return;
      var s = this.derive();
      this.volumeForm.querySelectorAll('[data-lgq-field]').forEach(function (input) {
        var key = input.getAttribute('data-lgq-field');
        if (key === 'work_setting' && s.work) input.value = s.work;
        if (key === 'quantity' && s.quantity) input.value = s.quantity;
      });
      slot.appendChild(this.volumeForm);
      this.volumeForm.hidden = false;
    },

    /* --- cart --- */
    setCartAttributes: function () {
      var r = this.resultData();
      return fetch(rootUrl() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { quiz_path: r.s.path || '', quiz_profile: r.id } })
      }).catch(function () {});
    },

    /* --- Klaviyo (no health answers) --- */
    sendToKlaviyo: function (email, consent) {
      var klaviyo = this.data.klaviyo || {};
      var r = this.resultData();
      var s = r.s;
      // Path D is a business follow-up, so the email is sent even without marketing consent
      if (!klaviyo.publicKey || !(consent || s.path === 'D')) return Promise.resolve();

      var properties = {
        quiz_path: s.path,
        quiz_profile: r.id,
        quiz_main_pick: (r.picks.bundle || r.picks.list.slice(0, 1)).join('+')
      };
      if (s.work) properties.quiz_work_setting = s.work;
      if (s.quantity) properties.quiz_quantity = s.quantity;

      var base = 'https://a.klaviyo.com/client/';
      var query = '?company_id=' + encodeURIComponent(klaviyo.publicKey);
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json', revision: '2024-10-15' };
      var requests = [
        fetch(base + 'events/' + query, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ data: { type: 'event', attributes: {
            properties: properties,
            metric: { data: { type: 'metric', attributes: { name: 'Lotgenootje Quiz Completed' } } },
            profile: { data: { type: 'profile', attributes: { email: email, properties: properties } } }
          } } })
        })
      ];

      if (consent && klaviyo.listId) {
        requests.push(fetch(base + 'subscriptions/' + query, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Lotgenootje quiz',
              profile: { data: { type: 'profile', attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: klaviyo.listId } } }
          } })
        }));
      }

      var settled = Promise.all(requests.map(function (request) { return request.catch(function () {}); }));
      var timeout = new Promise(function (resolve) { setTimeout(resolve, 2500); });
      return Promise.race([settled, timeout]);
    }
  };

  function init() {
    var app = document.querySelector('[data-lg-quiz-app]');
    if (!app || app.__lgQuiz) return;
    app.__lgQuiz = new Quiz(app, loadData());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    var app = document.querySelector('[data-lg-quiz-app]');
    if (app) app.__lgQuiz = null;
    init();
  });
})();
